<form [formGroup]="form" novalidate (ngSubmit)="prepareForSave()">

  <h5 mat-dialog-title>Ajouter une unité</h5>

  <!-- CONTENT -->
  <mat-dialog-content>

    <div class="col-12 mb-1">
      <mat-label>Unité :</mat-label>
      <textarea
        id="inputTitre"
        class="form-control w-100"
        formControlName="titre"
        required
        rows="5"
      ></textarea>

      <!-- FORM MESSAGE -->
      @if (form.invalid && (titre.dirty || titre.touched) && this.formSubmitAttempt) {
        <p class="text-right">
          @if (titre.errors.required) {
            <small class="danger text-muted">* Ce champs est requis</small>
          }
        </p>
      }
    </div>
    <div class="col-12">
      <mat-label>Code :</mat-label>
      <input  type="text"
        id="inputCode"
        class="form-control w-100"
        formControlName="code"
        required
        >

        <!-- FORM MESSAGE -->
        @if (form.invalid && (code.dirty || code.touched) && this.formSubmitAttempt) {
          <p class="text-right">
            @if (code.errors.required) {
              <small class="danger text-muted">* Ce champs est requis</small>
            }
          </p>
        }
      </div>


    </mat-dialog-content>

    <!-- ACTIONS -->
    <mat-dialog-actions>

      <button mat-button type="button" [mat-dialog-close]="false">Annuler</button>
      <button mat-raised-button color="primary" type="submit">Ajouter</button>

    </mat-dialog-actions>

  </form>
